<template>
  <span
    class="badge badge-pill badge-success badge-basket-count"
    :class="{ 'd-none': Object.keys(basket.items).length === 0 }"
  >
    <span class="woocommerce-Price-amount amount">
      <span class="woocommerce-Price-currencySymbol" v-if="basket.totals.total_exshipping > 0">{{
        basket.totals.total_exshipping | currencyWhole
      }}</span>
      <span class="" v-else>{{
      basket.totals.rangeto | currencyWhole
      }}
      </span>

    </span>
  </span>
</template>

<script>
export default {
  mounted() {},
  computed: {
    basket() {
      return this.$store.state.basket;
    },
  },
};
</script>